export const AppConfig = {
  env: import.meta.env.VITE_ENV,
  version: import.meta.env.VERSION,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  apiUrl: import.meta.env.VITE_API_URL ?? '',
};
